
import MyLoading from './module/MyLoading';
import bookmarkFilter from './module/bookmarkFilter';
import bookmarkLoad from './module/bookmarkLoad';
import bookmarkDelete from './module/bookmarkDelete';

(function() {
	const loading = new MyLoading();
	loading.watch();

	bookmarkFilter();
	bookmarkLoad();
	bookmarkDelete();
})();
